// removed by extract-text-webpack-plugin
module.exports = {"ratings":"Ratings__ratings___2tJ3P","text":"Ratings__text___1e0L1","icon":"Ratings__icon___2urcB"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/employer/candidateReview/components/Ratings.scss
// module id = 1868
// module chunks = 0